import {
  App,
  VerifyTotpCodeMfaRequest,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import { staticText as sharedText } from "@songtradr-sso/shared/frontend";
import { staticText } from "../../../shared/statics/static-text";
import { Api } from "../../../shared/utils/api.utils";

// TEXT
export const text = {
  ...staticText.mfa.totp.verify,
  shared: { inputs: sharedText.inputs },
};

// STYLES

// DATA
export const verifyTotpCode = (r: VerifyTotpCodeMfaRequest) => {
  return Api.post(endpoints.verifyTotpCode, r).then((resp) => resp.data);
};

// TYPES

// CONSTANTS
export const routes = allRoutes[App.Core];
const endpoints = fullEndpoints[App.Core].mfa;

// FUNCTIONS

// ASSETS
